var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"companyLog",on:{"click":function($event){return _vm.btnClickJump({
        name: '首页',
        id: '0',
        routerPath: '/'})}}},[_c('img',{attrs:{"src":require("../../assets/homePageImg/bar_logo@2x.png"),"alt":""}})]),_c('div',{staticClass:"navbar"},_vm._l((_vm.navTitle),function(item){return _c('div',{key:item.id,staticClass:"text"},[_c('div',{class:{ navindex: _vm.activeIndex == item.id ? true : false },on:{"click":function($event){return _vm.btnClickJump(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }